import { config } from "core/config/app"

// my ingredients
export const API_GET_INGREDIENTS = `${config.apiPrefix}/${config.apiVersion}/ingredients/autocomplete`
export const API_GET_MY_INGREDIENTS = `${config.apiPrefix}/${config.apiVersion}/ingredients/mine`
export const API_GET_LOCAL_MY_INGREDIENTS_BY_LANG = `${config.apiPrefix}/${config.apiVersion}/ingredients/my-ingredients`
export const API_UPDATE_MY_INGREDIENTS = `${config.apiPrefix}/${config.apiVersion}/ingredients/mine`
export const API_REQUEST_INGREDIENT = `${config.apiPrefix}/${config.apiVersion}/ingredients/request`
export const API_GET_FLAVORS = `${config.apiPrefix}/${config.apiVersion}/flavors`
export const API_GET_AI_HISTORY = `${config.apiPrefix}/${config.apiVersion}/ai/histories`

